export default __webpack_public_path__ + "static/media/1.5cb8c08f.jpg";